<template>
  <div>
    <gmap-map :center="center" :zoom="int_zoom" style="width:100%; height:100vh;" :options="options">
      <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :draggable="false" :icon="m.icon" @drag="updateMaker" @click="center=m.position">
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import { Image } from 'vant';
import StoreInfoVue from '../common/StoreInfo.vue';
export default {
  name: "HelloWorld",
  props: {
    address: {
      type: Object,
      default: () => {
        return {
          merchant: {
            position: { lat: '', lng: '' },
            addr: '',
            icon: ''
          },
          customer: {
            position: { lat: '', lng: '' },
            addr: '',
            icon: ''
          },
          driver: {
            position: { lat: '', lng: '' },
            addr: '',
            icon: ''
          }
        }
      }
    }
  },
  data() {
    return {
      int_zoom: 16,
      center: { lat: 3.139003, lng: 101.686855 },
      markers: [],
      places: [],
      currentPlace: null,
      value: {},
      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  },
  created() {
    const { merchant, customer, driver } = this.address
    this.settingMapCenterPosition(driver) //设置地图的中记位置

    this.initAddrMerchant(merchant)
    this.initAddrCustomer(customer)
    this.initAddrDriver(driver)
    this.refreshData(driver)
  },
  mounted: function() {
  },

  methods: {
    refreshData(addr){
      setInterval(() => { {
        
        const marker = {
        lat: parseFloat(addr.location.coordinate.lat),
        lng: parseFloat(addr.location.coordinate.lng)
      };
      console.log('marker#initAddrDriver >>>', marker);
      this.markers.push({icon: this.getSiteIcon(3)});
      this.places.push(addr.addr);

      addr.location.coordinate = {
        lat: marker.lat,
        lng: marker.lng,
      }

     this.markers[2].position = {
        lat: addr.location.coordinate.lat,
        lng: addr.location.coordinate.lng,
      }     
    
      if (this.currentPlace) { {
        this.markers.position = [];
        for (let i=0;i<marker.length;i++){
          const marke = {
            lat: this.markers[i].lat,
            lng: this.markers[i].lng,
          };
          console.log('marker >>>', marke);
          this.markers.push({ position: marke, icon: this.getSiteIcon(3)});
          this.places.push(this.currentPlace);
          this.center = marke;
        }
      } } }
      },10000)
    },
    initAddrMerchant(addr) {
      this.currentPlace = addr.addr
      const marker = {
        lat: parseFloat(addr.location.coordinate.lat),
        lng: parseFloat(addr.location.coordinate.lng),
      };
      console.log('marker#initAddrMerchant >>>', addr);
      this.markers.push({ position: marker, icon: this.getSiteIcon(1)});
      this.places.push(addr.addr);
    },
    initAddrCustomer(addr) {
      const marker = {
        lat: parseFloat(addr.location.coordinate.lat),
        lng: parseFloat(addr.location.coordinate.lng)
      };
      console.log('marker#initAddrCustomer >>>', marker);
      this.markers.push({ position: marker, icon: this.getSiteIcon(2)});
      this.places.push(addr.addr);
    },
    initAddrDriver(addr) {
      const marker = {
        lat: parseFloat(addr.location.coordinate.lat),
        lng: parseFloat(addr.location.coordinate.lng)
      };
      console.log('marker#initAddrDriver >>>', marker);
      this.markers.push({ position: marker, icon: this.getSiteIcon(3)});
      this.places.push(addr.addr);
    },
    
    addMarker() {
      if (this.currentPlace) { {
        this.markers = [];
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        console.log('marker >>>', marker);
        this.places.push(this.currentPlace);
        this.center = marker;
        for (let i=0;i<marker.length;i++){
          this.markers.push({
            position: marker[i],
            icon: this.getSiteIcon(1)
          });
        }
        //this.currentPlace = null;
      }
    return this.markers; }
    },
    getSiteIcon(status){
     // $logo = pdo_fetchall("SELECT logo FROM ims_weisrc_dish_stores WHERE id=" + 'storeid');
      try{
        switch (status){
          case 1:
            return {size: {width: 120, height: 120, f: 'px', b: 'px',}, scaledSize: {width: 30, height: 30, f: 'px', b: 'px',}, url: require("@/assets/merchant.png") }/*, require("@/assets/Merchant.png")*/;
          case 2:
            return {size: {width: 120, height: 120, f: 'px', b: 'px',}, scaledSize: {width: 30, height: 30, f: 'px', b: 'px',}, url: require("@/assets/user.png")}/*, require("@/assets/User.png")*/;
          case 3:
            return {size: {width: 120, height: 120, f: 'px', b: 'px',}, scaledSize: {width: 30, height: 30, f: 'px', b: 'px',}, url: require("@/assets/driver.png")}/*, require("@/assets/delivery.png")*/;
        }
      } catch(e) {return null;}
    },
    settingMapCenterPosition(customer) {
      
       console.log('设置地图中心点 >>>', customer);
      this.center.lat = customer.location.coordinate.lat
      this.center.lng = customer.location.coordinate.lng
      this.currentPlace = customer.addr || '';
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        console.log('position >>>', position);
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.markers.push({ position: this.center });
      });
    },
    updateMaker: function (event) {
      console.log('updateMaker new latitude, ', event.latLng.lat());
      console.log('updateMaker new longitude, ', event.latLng.lng());
      this.markers[2].position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      }
      this.addMarker();
    },
  }
};
</script>